import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-height: 200px;
    max-width: 200px;
  }
`;

export const ProductHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${Tokens.spacing[1]};
  cursor: pointer;
  user-select: none;
`;

export const ArrowIconWrapper = styled.span<{ isOpen: boolean }>`
  button {
    ${(props) => !props.isOpen && 'transform: rotate(-90deg)'};
    transition: transform 0.2s ease;
  }
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${FullPalette.EVERGREEN_E100};
  color: ${FullPalette.EVERGREEN_E500};
  font-size: 12px;
  font-weight: 500;
`;

export const ReadBadge = styled(Badge)`
  background-color: ${FullPalette.EVERGREEN_E100};
  color: ${FullPalette.EVERGREEN_E500};
`;

export const WriteBadge = styled(Badge)`
  background-color: #fff3e0;
  color: #e65100;
`;

export const ScopeItemWrapper = styled.div`
  padding-left: 24px;
`;

export const AccessTypeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${FullPalette.EVERGREEN_E100};
  margin: 8px 0;
`;
